module.exports = __webpack_public_path__ + "files/chp.b0def26ab50cfad92185797e4112162c.pdf";